module.exports = __webpack_public_path__ + "images/assets/ba4bd4772fc7b03e4c8791a243d1651a.svg";